
import { VBtn } from 'vuetify/lib';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({ name: 'd4y-btn' })
export default class D4yBtn extends VBtn {
  @Prop({ default: false })
  rounded!: boolean;
}
